import styled from "styled-components"
import { useTranslation } from "react-i18next";

const Policy = () => {
  const {t} = useTranslation();
  return (
    <Wrapper className="container">
      <div className="row">
        <div className="col-12">
          <h1>Privacy Policy</h1>
        </div>
        <div className="col-12 col-md-6">
          <p>
            {t('policy1')} <a className="link" href="https://www.hotel.bb/booking-engine.php">Hotel.BB</a>{t('policy2')} <a className="link" href="https://www.zucchetti.it/it/cms/service/privacy.html">link</a> {t('policy3')}
          </p>
        </div>
      </div>
    </Wrapper>
  )
}

export default Policy;

const Wrapper = styled.div`
  padding: 0px 0px 30px;
  .row {
    .link {
      color: var(--logo);
    }
    .col-md-6 {
      margin-top: 15px;
    }
    padding: 15px;
  }
`
